import React, { createContext, useContext, useEffect, useState } from "react";
import hu from "./hu";
import en from "./en";
import sk from "./sk";
import de from "./de";

export const LANGUAGES = { hu, en, sk, de };
export const LANG_LIST = [hu, en, sk, de];
const STORAGE_KEY = "salesshark-lang";

const LanguageContext = createContext({
    lang: "hu",
    t: hu,
    setLang: () => {},
});

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "hu";
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (stored && LANGUAGES[stored]) return stored;
        // Detect from browser
        const browser = (window.navigator.language || "hu").slice(0, 2);
        return LANGUAGES[browser] ? browser : "hu";
    });

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.localStorage.setItem(STORAGE_KEY, lang);
            document.documentElement.lang = LANGUAGES[lang].htmlLang;
        }
    }, [lang]);

    const setLang = (next) => {
        if (LANGUAGES[next]) setLangState(next);
    };

    const t = LANGUAGES[lang] || LANGUAGES.hu;

    return (
        <LanguageContext.Provider value={{ lang, t, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
}

export const useT = () => useContext(LanguageContext);
